export default __webpack_public_path__ + "eb1faa7c771c4d7de2bcb9ec16073ae4.png";